import Timer from "../components/Timer";
import NewWordForm from "../components/NewWordForm";
import VotingChart from "../components/VotingChart";


function CurrentVotingPage() {
  return (
      <div>
        <NewWordForm maxInputLength={32}/>
        <hr />
        <Timer />
        <hr />
        <VotingChart limit={30} votingId={-1}/>
      </div>
  );
}

export default CurrentVotingPage;
